<template>
	<div class="news">
		<pageCart title="Nyheder">
			<div class="items">
				<item v-for="item in items" :key="item.id" v-bind="item"/>
			</div>
		</pageCart>
	</div>
</template>

<script>
import pageCart from "@/components/layouts/page/cart.vue";
import item from "./item.vue";

export default {
	components: {pageCart, item},
	data() {
		return {
			items: []
		}
	},
	methods: {
		async getItems() {
			const {data: {data}} = await this.$axios.get("client/news-items", {params: {count: 1000, sort: "-published_at"}});
			this.items = data;
		}
	},
	created() {
		this.getItems();
	}
};
</script>

<style lang="scss" scoped>
.news {

}
</style>
